import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Button, Card, ConfigProvider, Descriptions, Flex } from 'antd';
import { useTranslation } from 'translations/hooks';

import { SegmentHistory } from 'business/quality-control/pages/segment-history/hooks/data/types';

export const DetailsHeader = ({
  segment,
  nextSegment,
  previousSegment,
  setSelectedSegment,
}: {
  segment: SegmentHistory;
  nextSegment: SegmentHistory | undefined;
  previousSegment: SegmentHistory | undefined;
  setSelectedSegment: (segment: SegmentHistory) => void;
}) => {
  const { t } = useTranslation();

  const items = [
    {
      key: 'serialNumber',
      label: t(
        'qualityControl.segmentHistory.drawer.segmentInfos.serialNumber',
      ),
      children: segment.serialNumber ?? '-',
    },
    {
      key: 'segmentType',
      label: t('qualityControl.segmentHistory.drawer.segmentInfos.segmentType'),
      children: segment.segmentType ?? '-',
    },
  ];

  return (
    <Flex gap={4} align="center">
      <Button
        type="text"
        icon={<LeftOutlined />}
        style={{ flex: 1 }}
        disabled={!previousSegment}
        onClick={() => previousSegment && setSelectedSegment(previousSegment)}
      />
      <Card style={{ flex: 15 }}>
        <ConfigProvider
          theme={{
            components: {
              Descriptions: {
                itemPaddingBottom: 4,
                labelColor: '#595959',
              },
            },
          }}
        >
          <Descriptions
            items={items}
            colon={false}
            layout="vertical"
            column={2}
          />
        </ConfigProvider>
      </Card>
      <Button
        type="text"
        icon={<RightOutlined />}
        style={{ flex: 1 }}
        disabled={!nextSegment}
        onClick={() => nextSegment && setSelectedSegment(nextSegment)}
      />
    </Flex>
  );
};
